import { useMutation, useQueryClient } from '@tanstack/react-query';
import { managedLighthouseQueryKeys, networkQueryKeys, Networks } from '#api';
import { makeNetworkConfigOverridesQueryOptions, makeNetworkQueryOptions } from '#api/networks.queries.ts';

export function useAddNetwork() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: Networks.addNetwork,
    onSuccess: async (data) => {
      queryClient.setQueryData(makeNetworkQueryOptions(data.id).queryKey, { data });
      // Network responses don't carry managed-lighthouse state — creating a network also creates
      // its tenancy, so refetch the managed-lighthouses list for the new pending entry.
      void queryClient.invalidateQueries({ queryKey: managedLighthouseQueryKeys.all() });
      await queryClient.invalidateQueries({ queryKey: networkQueryKeys.lists() });
    },
  });
}

export function useAddNetworkCIDR() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: Networks.addNetworkCIDR,
    onSuccess: (data, variables) => {
      void queryClient.invalidateQueries({ queryKey: networkQueryKeys.lists() });
      queryClient.setQueryData(makeNetworkQueryOptions(variables.id).queryKey, { data });
    },
  });
}

export function useEditNetwork() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: Networks.editNetwork,
    onSuccess: (data, variables) => {
      void queryClient.invalidateQueries({ queryKey: networkQueryKeys.lists() });
      // Network responses don't carry managed-lighthouse state — an edit may have toggled
      // disableManagedLighthouses, so refetch the managed-lighthouses list to pick up the torn
      // down / reactivated tenancy.
      void queryClient.invalidateQueries({ queryKey: managedLighthouseQueryKeys.all() });
      queryClient.setQueryData(makeNetworkQueryOptions(variables.id).queryKey, { data });
    },
  });
}

export function useSetNetworkConfigOverrides() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: Networks.setNetworkConfigOverrides,
    onSuccess: (data, variables) => {
      queryClient.setQueryData(makeNetworkConfigOverridesQueryOptions(variables.id).queryKey, { data });
    },
  });
}
